import dayjs from 'dayjs';

import { DATE_FORMAT, DATETIME_FORMAT, DateTimeType, TIME_FORMAT } from '@webapp/common/lib/date';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

const convertDatetime = (
    dateType: DateTimeType,
    answers: Array<{ answer: number; text: string; bool: boolean }>,
): any => {
    if (!Array.isArray(answers)) {
        return answers;
    }

    return answers.map((answer) => {
        let text = '';
        const date = dayjs(answer.text);
        switch (dateType) {
            case DateTimeType.DATE: {
                text = date.format(DATE_FORMAT);
                break;
            }
            case DateTimeType.DATE_TIME: {
                text = date.format(DATETIME_FORMAT);
                break;
            }
            case DateTimeType.TIME: {
                text = date.format(TIME_FORMAT);
                break;
            }
        }
        return { ...answer, text };
    });
};

export class DatetimeApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const {
            answersActors,
            id,
            params: { dateType },
            responseActor,
        } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: convertDatetime(
                dateType,
                answersActors.map((answerActor) => {
                    const { id, response } = answerActor.getSnapshot().context;
                    const { value } = response.getSnapshot().context;
                    return {
                        answer: id,
                        text: String(value ? String(value) : ''),
                        bool: true,
                    };
                }),
            ),
            comment,
        };
    }

    public validate({ answersActors, params: { required } }: QuestionContext): boolean {
        if (!required) return true;

        const notEmptyAnswers = answersActors.reduce(
            (acc, answerActor) =>
                acc + Number(Boolean(answerActor.getSnapshot().context.response.getSnapshot().context.value)),
            0,
        );

        return notEmptyAnswers === answersActors.length;
    }
}
